/**
 * Constantes core du circuit breaker - Sans dépendances UI
 * Ce fichier peut être copié tel quel dans les workers
 */

/**
 * États possibles du circuit breaker
 */
export const CIRCUIT_STATES = {
  CLOSED: 'CLOSED',       // Fonctionnel
  OPEN: 'OPEN',          // En défaillance
  HALF_OPEN: 'HALF_OPEN' // En test de récupération
};

/**
 * Codes de statut standardisés pour le frontend
 */
export const STANDARD_STATUS_CODES = {
  OK: 200,                    // Succès
  ERROR: 400,                 // Erreur générale
  AUTH_ERROR: 401,            // Erreur de clé API
  NOT_FOUND: 404,             // Erreur de route
  SYNTAX_ERROR: 422,          // Erreur de syntaxe
  REQUEST_TIMEOUT: 408,       // Erreur de timeout
  QUOTA_ERROR: 429,           // Erreur de quota
  SERVER_ERROR: 500,          // Erreur serveur
  SERVER_NO_ANSWER: 503       // Pas de réponse du serveur
};

/**
 * Codes d'état du worker (codes 9xx)
 * Ces codes sont générés directement par le worker sans appel API externe
 */
export const WORKER_STATE = {
  OK: 920,                    // Succès worker
  AUTH_ERROR: 940,            // Clé API manquante
  NOT_FOUND: 941,             // Erreur de route
  SERVER_ERROR: 950           // Erreur serveur du worker
};

/**
 * Types d'erreurs (version core sans icônes)
 * Synchronisé avec la version UI du frontend
 */
export const ERROR_TYPES_CORE = {
  connectivity: {
    type: 'connectivity',
    translationKey: 'ERROR_TYPE_CONNECTIVITY',
    defaultText: 'Connectivité',
    cssClass: 'status-error--connectivity'
  },
  auth: {
    type: 'auth',
    translationKey: 'ERROR_TYPE_AUTH',
    defaultText: 'Authentification',
    cssClass: 'status-error--auth'
  },
  service: {
    type: 'service',
    translationKey: 'ERROR_TYPE_SERVICE',
    defaultText: 'Service',
    cssClass: 'status-error--service'
  },
  api: {
    type: 'api',
    translationKey: 'ERROR_TYPE_API',
    defaultText: 'API',
    cssClass: 'status-error--api'
  },
  watchdog: {
    type: 'watchdog',
    translationKey: 'ERROR_TYPE_WATCHDOG',
    defaultText: 'Appels répétés détectés',
    cssClass: 'status-error--watchdog'
  },
  unknown: {
    type: 'unknown',
    translationKey: 'ERROR_TYPE_UNKNOWN',
    defaultText: 'Erreur inconnue',
    cssClass: 'status-error--unknown'
  }
};
